<template>
  <div class="qiao_qi_warp">
    <div class="div_info">各社区人口分布</div>
    <div class="mapWarp">
      <div id="container" ref="container"></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      map: null,
    };
  },
  created() {},
  mounted() {
    this.mapList();
  },
  methods: {
    mapList() {
      this.map = new BMap.Map(this.$refs.container); // 创建Map实例
      this.map.centerAndZoom(new BMap.Point(116.404, 39.915), 11); // 初始
      this.map.enableScrollWheelZoom(true);
      this.getBoundary();
    },
    getBoundary() {
      this.map.clearOverlays(); // 清除地图的其余覆盖物
      const bdary = new BMap.Boundary();
      bdary.get("北京", (rs) => {
        const count = rs.boundaries.length;
        if (count === 0) {
          return;
        }
        const EN_JW = "180, 90;";
        const NW_JW = "-180,  90;";
        const WS_JW = "-180, -90;";
        const SE_JW = "180, -90;";
        // 东南西北四个角添加一个覆盖物
        const ply1 = new BMap.Polygon(
          rs.boundaries[0] + SE_JW + SE_JW + WS_JW + NW_JW + EN_JW + SE_JW,
          {
            strokeColor: "none",
            fillColor: "#333",
            fillOpacity: 1,
            strokeOpacity: 1,
          }
        );
        // 添加覆盖物
        //  var ply1 = new BMap.Polygon(rs.boundaries[0] + SE_JW + SE_JW + WS_JW + NW_JW + EN_JW + SE_JW, { strokeColor: "none", fillColor: "rgb(246,246,246)", fillOpacity:1, strokeOpacity: 0.5 }); //建立多边形覆盖物
        // this.map.addOverlay(ply1);
        //5. 给目标行政区划添加边框，其实就是给目标行政区划添加一个没有填充物的遮罩层
        var ply = new BMap.Polygon(rs.boundaries[0], {
          strokeWeight: 2,
          strokeColor: "#00f",
          fillColor: "",
        });

        this.map.addOverlay(ply);
        this.map.setViewport(ply.getPath()); //调整视野
      });
    },
  },
};
</script>

<style scoped lang="less">
.qiao_qi_warp {
  width: 100%;
  height: 350px;
  //   margin: 0 20px;
  // box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  .div_info {
    padding-bottom: 20px;
  }
  .mapWarp {
    width: 100%;
    height: 95%;
    overflow: hidden;
    #container {
      width: 100%;
      height: 95%;
    }
  }
}
</style>
